import React from "react";
import PolicyLayout from "@/components/PolicyLayout";

export default function Terms() {
  return (
    <PolicyLayout
      title="Terms &amp; conditions"
      description="Terms and conditions of sale for PeptiChill products purchased via peptidecooler.co.uk."
      path="/terms"
      eyebrow="Legal"
      lastUpdated="February 2026"
    >
      <h2>1. About us</h2>
      <p>
        PeptiChill is a trading name operated alongside <strong>Peptigen Labs</strong>{" "}
        in the United Kingdom. {/* [REVIEW – confirm legal entity name &amp; company number once finalised] */}
        These terms govern the purchase of products from peptidecooler.co.uk.
      </p>

      <h2>2. Pricing</h2>
      <p>
        All prices are shown in pounds sterling (GBP) and where applicable include UK VAT
        at the prevailing rate. Delivery charges are shown separately at checkout. We
        reserve the right to update pricing at any time, but the price you pay is the
        price displayed when your order is confirmed.
      </p>

      <h2>3. Order acceptance</h2>
      <p>
        Placing an order is an offer to buy. A contract is formed only when we email you
        an order confirmation. If we cannot fulfil an order — for example due to stock
        availability or a pricing error — we will notify you and refund any amount paid.
      </p>

      <h2>4. Payment</h2>
      <p>
        Payment is taken at checkout via our payment provider (Stripe). We accept Visa,
        Mastercard, American Express, Apple Pay and other supported methods displayed at
        checkout. Your payment details are processed by Stripe and are not stored on our
        servers.
      </p>

      <h2>5. Delivery &amp; risk</h2>
      <p>
        Delivery terms are set out in our <a href="/delivery">Delivery policy</a>. Risk in
        the goods passes to you on delivery to the address you provided.
      </p>

      <h2>6. Cancellations &amp; returns</h2>
      <p>
        Your statutory rights, including the 14-day right to cancel under the UK Consumer
        Contracts Regulations, are described in our{" "}
        <a href="/returns">Returns policy</a>.
      </p>

      <h2>7. Warranty</h2>
      <p>
        PeptiChill products are supplied with a <strong>12-month manufacturer warranty</strong>{" "}
        covering manufacturing defects under normal use. The warranty does not cover
        damage caused by misuse, modification, or failure to follow the instructions
        provided with the product. Your statutory rights under the Consumer Rights Act
        2015 are unaffected.
      </p>

      <h2>8. Intended use</h2>
      <p>
        PeptiChill products are sold as <strong>temperature-controlled storage equipment</strong>.
        They are not medical devices and do not provide medical advice. See our{" "}
        <a href="/disclaimer">Disclaimer</a> for details.
      </p>

      <h2>9. Liability</h2>
      <p>
        Nothing in these terms limits our liability for death or personal injury caused by
        our negligence, for fraud, or for any liability that cannot be excluded by law.
        Subject to that, our total liability under or in connection with these terms shall
        not exceed the price paid for the product giving rise to the claim.
      </p>

      <h2>10. Governing law</h2>
      <p>
        These terms are governed by the laws of <strong>England and Wales</strong>, and
        the courts of England and Wales have exclusive jurisdiction.
      </p>

      <h2>11. Contact</h2>
      <p>
        Questions? Email{" "}
        <a href="mailto:hello@peptidecooler.co.uk">hello@peptidecooler.co.uk</a>.
      </p>
    </PolicyLayout>
  );
}
